import '@fontsource/sora/400.css'
import '@fontsource/sora/600.css'

import * as Sentry from '@sentry/react'
import { StrictMode, Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { ensureAppStyles, scheduleAppStyles } from './lib/loadStyles.js'
import SecurityProviders from './providers/SecurityProviders.jsx'
import SolutionFinderProvider from './providers/SolutionFinderProvider.jsx'
import { ThemeProvider } from './providers/ThemeProvider.jsx'
import { ToastProvider } from './components/ToastProvider.jsx'

const SolutionFinderModal = lazy(() => import('./components/SolutionFinderModal.jsx'))

// Sentry Init Check
if (!window.sentryInitialized) {
    Sentry.init({
        dsn: 'https://e19517083c2a59373c4da296afc020d2@o4510397209051136.ingest.de.sentry.io/4510397258334288',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    })
    window.sentryInitialized = true;
}

if (typeof window !== 'undefined') {
    scheduleAppStyles()
    if (document.readyState !== 'loading') {
        ensureAppStyles()
    } else {
        window.addEventListener('DOMContentLoaded', () => ensureAppStyles(), { once: true })
    }
}

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <Sentry.ErrorBoundary fallback={<p>Es ist ein Fehler aufgetreten.</p>}>
            <SecurityProviders>
                <ThemeProvider>
                    <ToastProvider>
                        <SolutionFinderProvider>
                            <BrowserRouter>
                                <App />
                                <SpeedInsights />
                                <Suspense fallback={null}>
                                    <SolutionFinderModal />
                                </Suspense>
                            </BrowserRouter>
                        </SolutionFinderProvider>
                    </ToastProvider>
                </ThemeProvider>
            </SecurityProviders>
        </Sentry.ErrorBoundary>
    </StrictMode>,
)